import { render, staticRenderFns } from "./AppBarProfile.vue?vue&type=template&id=b33208d2&"
import script from "./AppBarProfile.vue?vue&type=script&lang=js&"
export * from "./AppBarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b33208d2')) {
      api.createRecord('b33208d2', component.options)
    } else {
      api.reload('b33208d2', component.options)
    }
    module.hot.accept("./AppBarProfile.vue?vue&type=template&id=b33208d2&", function () {
      api.rerender('b33208d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppBarProfile.vue"
export default component.exports